import axios from 'axios'
import session from '../store/modules/session'
import { calculateDistanceLocation } from '@/plugins/geolocation'

async function getDeviceFromNearedShop() {
  try {
    let url = process.env.VUE_APP_PATH + 'getInfoLocationDevices'
    const response = await axios.get(url, null)
    const actualShop = getMostNearRangeShop(response.data.result)

    return actualShop
  } catch (err) {
    console.log(err)
    return null
  }
}

function getMostNearRangeShop(shops) {
  let shopDetected, distanceDetected
  shops.forEach((shop) => {
    let actualDistanceShop = getRangeUserFromShop(shop.latitude, shop.longitude)
    if (!shopDetected) {
      shopDetected = shop
      distanceDetected = actualDistanceShop
    } else if (actualDistanceShop < distanceDetected) {
      shopDetected = shop
      distanceDetected = actualDistanceShop
    }
  })

  return shopDetected
}

function getRangeUserFromShop(latitudeStore, longitudeStore) {
  return calculateDistanceLocation(
    latitudeStore,
    longitudeStore,
    session.state.latitude,
    session.state.longitude
  )
}

export default getDeviceFromNearedShop
